import { useMemo } from 'react';

/**
 * Custom hook to check if the user has multiple avatar wallets.
 * @function useHasMultipleAvatarWallets
 * @param {string[]} avatarWallets - The list of avatar wallet addresses.
 * @returns {boolean} True if the user has multiple avatar wallets, false otherwise.
 */
export const useHasMultipleAvatarWallets = (avatarWallets: string[]) => {
  return useMemo(() => avatarWallets?.length > 1, [avatarWallets]);
};
